<!--  -->
<template>
    <div class="container">
        <img class="container-pdf" src="../assets/pdf.png" alt="">
        <div class="container-title">{{ invitation.title }}</div>
        <div class="container-content">
            <!-- <img style="margin-right: 5px;" src="../assets/time.png" alt=""> -->
            {{ invitation.articleDate }}
        </div>
        <div class="container-addr">
            <!-- <img style="margin-right: 5px;" src="../assets/place.png" alt=""> -->
            地点：{{ invitation.addr }}
        </div>
        <img class="container-button" @click="onDownload" src="../assets/start.png" alt="">
        <div style="margin-top: 10px;font-size: 12px;">（点击下载，选择右上角，在浏览器中打开，即可下载文件或转发至微信）</div>
    </div>
</template>

<script>
import { getQueryTemp } from '../api/forms';
import { Notify, Dialog } from 'vant';
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
            invitation: {},
            articleType: this.$route.query.articleType || "",
            pay: this.$route.query.pay || "",
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        QueryTemp() {
            let data = {
                articleType: this.articleType,
                pay: this.pay,
                // articleType: 2,
                // pay: 1
            }
            getQueryTemp(data).then((res) => {
                // if (res.code == 200 && res.data != null) {
                //     this.invitation = res.data
                // }
                // else {
                //     this.$router.push("/State?openId=" + this.openId);
                // }
                if (res.code == 200) {
                    this.invitation = res.data
                }
                else {
                    Notify({ type: 'warning', message: res.msg, duration: 6000 });
                }
            })
        },
        //下载
        onDownload() {
            window.location.href = this.invitation.url
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.QueryTemp()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
.container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    font-family: 'FZLTXHJW';
    width: 100%;
    background-image: url('../assets/pdfBg.png');
    background-size: 100% auto;
    background-repeat: no-repeat;
    position: relative;
    overflow: hidden;

    .container-pdf {
        width: 80px;
        height: 80px;
    }

    .container-title {
        margin-top: 10px; // 可以根据需要调整间距
        font-size: 13px;
        text-align: center;
    }

    .container-content {
        margin-top: 30px; // 可以根据需要调整间距
        font-size: 13px;
        text-align: center;
        display: flex;
        align-items: center;

        img {
            width: 15px;
        }
    }

    .container-addr {
        margin-top: 10px; // 可以根据需要调整间距
        font-size: 13px;
        width: 130px;
        text-align: center;
        margin-bottom: 30px;
        // display: flex;
        align-items: center;

        img {
            width: 15px;
        }
    }


    .container-button {
        margin-top: 10px; // 可以根据需要调整间距
        width: 150px;
    }
}
</style>